import React from 'react'
import styled from 'styled-components'
import { Block, BlockGroup, Button, H2, H3, P } from '@mote/ui'
import { Content, DefaultLayout } from '../layouts'

export const CommunityScreen = () => {
  return (
    <DefaultLayout>
      <Content>
        <Block as='figure' align='center' margin='30px auto 70px auto' gap={10}>
          <Image
            src='images/logos/mote-ambassadors.png'
            alt='mote community'
            width='300'
          />
        </Block>

        <SkewedBackground align='center'>
          <BlockGroup
            as='article'
            maxWidth={672}
            margin='0 auto 0 auto'
            gap={60}
          >
            <Block>
              <H2 alignment='center'>The Mote Community</H2>
            </Block>

            <Block gap={15}>
              <P fontSize={18}>
                Here at Mote, we’re on a mission to help everyone use voice
                messaging to make their communication faster, friendlier and
                more effective.
              </P>

              <P fontSize={18}>
                If you’re passionate about harnessing your voice, if you want to
                learn new ways to raise your feedback game, and if you’d like to
                get more involved with Mote, then we would love you to become a
                member of our community.
              </P>
            </Block>

            <Block gap={20}>
              <H3>Join the conversation</H3>
              <P fontSize={18}>
                We have a lively Mote{' '}
                <a
                  href='https://www.facebook.com/groups/736374953859823/'
                  className='mote-boiler-link'
                >
                  Facebook group
                </a>{' '}
                filled with a diverse group of global educators.
              </P>

              <P fontSize={18}>
                Members are free to discuss any and all aspects of the feedback
                experience, as well as engaging in discussions about our
                products, marketing and strategy.
              </P>
            </Block>

            <Block gap={20}>
              <H3>
                Become a Mote Certified Educator{' '}
                <b className='mote-purple'>#MOTECE</b>
              </H3>
              <P fontSize={18}>
                Demonstrate your Mote knowledge and earn an exclusive
                certificate by becoming a Mote Certified Educator.
              </P>

              <Button
                variant='link'
                text='Apply now'
                tag='a'
                href='https://docs.google.com/forms/d/e/1FAIpQLScofp80GLsF_UyPddoxtTqDIr9Mkz77UhS4Ttfaops24DbIWg/viewform?usp=sf_link'
              />
            </Block>

            <Block gap={20} margin='0 0 100px 0'>
              <H3>Become a Mote Ambassador</H3>
              <P fontSize={18}>
                Think you've got what it takes to reach the pinnacle of Mote
                expertise? If you're already a{' '}
                <b className='mote-purple'>#MOTECE</b> then you're ready to
                begin your journey to becoming a Mote Ambassador.
              </P>
              <Button
                variant='link'
                text='Apply now'
                tag='a'
                href='https://docs.google.com/forms/d/e/1FAIpQLSfX4RFah5FpsZ4blAy-xret_XJywxvOQAI4VTvJJlpkomUs0w/viewform?usp=sf_link'
              />
            </Block>
          </BlockGroup>
        </SkewedBackground>
      </Content>
    </DefaultLayout>
  )
}

const Image = styled.img`
  padding: 0.5rem;
  background-color: #f8f9fa;
  border: 0 solid #dee2e6;
  border-radius: 0.375rem;
  box-shadow: 0 0.5rem 1rem rgb(0 0 0 / 15%);
`

const SkewedBackground = styled(Block)`
  position: relative;

  &::before {
    background-color: #f8f9fa;
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transform: skewY(-5deg);
    transform-origin: top left;
    z-index: -1;
  }
`
